import classNames from 'classnames';
import { LinkFactoryReactRouter } from 'common/link/link-react-router.js';
import { MouseEvent } from 'react';

import { IMenuItem } from 'types/menu.js';

export type NavMenuItemOnClick = ({
  item,
  event,
}: {
  item: IMenuItem;
  event: MouseEvent<HTMLAnchorElement>;
}) => void;

interface IProps {
  item: IMenuItem;
  active?: boolean;
  className?: string;
  onClick?: NavMenuItemOnClick;
}

export const NavMenuItem = ({ item, active, className, onClick }: IProps) => {
  const { name, link, target } = item;
  const classes = classNames(className, { 'is-active': active });

  return (
    <li className={classes}>
      <LinkFactoryReactRouter href={link} target={target} onClick={(event) => onClick?.({ item, event })}>
        {name}
      </LinkFactoryReactRouter>
    </li>
  );
};
